module.exports = __webpack_public_path__ + "img/cash-book.8d788d73.svg";